const GOOGLE_SHARE_HOSTS = new Set([
  'maps.app.goo.gl',
  'goo.gl',
  'g.page',
  'maps.google.com',
]);

export function isValidGoogleShareLink(url: string): boolean {
  const trimmed = url.trim();
  if (!trimmed.toLowerCase().startsWith('https://')) {
    return false;
  }
  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.toLowerCase();
    if (GOOGLE_SHARE_HOSTS.has(host)) {
      return true;
    }
    if (host === 'google.com' || host.endsWith('.google.com')) {
      return parsed.pathname.toLowerCase().includes('/maps');
    }
    return false;
  } catch {
    return false;
  }
}
